import(/* webpackMode: "eager" */ "/app/src/app/(public)/ve-may-bay/loading.tsx");
